// extracted by mini-css-extract-plugin
export default {"link":"UU-z","disabled":"VU-z"};